import React from 'react';
export default function usePages(count, page, pageListWidth, buttonWidth) {
  return React.useMemo(function () {
    var upperLimit;
    var lowerLimit;

    if (pageListWidth !== null && pageListWidth > 0 && count > 0) {
      var limit = Math.round(pageListWidth / buttonWidth);
      var half = Math.ceil(limit / 2);

      if (page - half < 0) {
        lowerLimit = 0;
        upperLimit = Math.min(lowerLimit + limit, count);
      } else if (page + half > count) {
        upperLimit = count;
        lowerLimit = Math.max(0, upperLimit - limit);
      } else {
        lowerLimit = page - half;
        upperLimit = Math.min(lowerLimit + limit, count);
      }
    }

    return {
      upperLimit: upperLimit,
      lowerLimit: lowerLimit,
      showFirstPage: lowerLimit > 0,
      showLastPage: upperLimit < count,
      showPrevPage: page > 0,
      showNextPage: page < count - 1,
      showPrevDots: lowerLimit > 1,
      showNextDots: upperLimit < count - 1
    };
  }, [count, page, pageListWidth, buttonWidth]);
}